// TOP LEVEL IMPORTS
import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Jumbotron from './Jumbotron';
import CallOutSection from './CallOutSection';
import PlansSection from './PlansSection';
import CarouselSection from './CarouselSection';

class AppHome extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <Jumbotron />
        <PageContainer>
          <CarouselSection />
        </PageContainer>
        <PlansSection history={this.props.history} />
        <CallOutSection />
      </React.Fragment>
    );
  }
}

AppHome.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default AppHome;



// WEBPACK FOOTER //
// ./src/routes/app-home/index.js